module.exports = __webpack_public_path__ + "img/square-this-way-up.16e6fbf2.svg";